import { render } from "./TextInstruction.vue?vue&type=template&id=da6319c8&scoped=true"
import script from "./TextInstruction.vue?vue&type=script&lang=js"
export * from "./TextInstruction.vue?vue&type=script&lang=js"

import "./TextInstruction.vue?vue&type=style&index=0&id=da6319c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da6319c8"]])

export default __exports__